module.exports = __webpack_public_path__ + "./images/cec054454f02a8a4d155afef763d298e.webp";